import * as React from 'react';
import CommentListStore from './store';
import CommentList from '../../components/biz/commentList';
import {ICommonCommentItem} from '../../apis/comment/commonApiAdapter';
import {commonParamBuilder} from '../../../lib/paramBuilder';
import queryString from 'query-string';
import {callSdkMethod} from '../../common/sdkWrap';

if (process.env.BROWSER) {
  require('./index.less');
}

export interface ICommentListContainerProp {
  commentStore?: CommentListStore;
}

export default class CommentListContainer extends React.Component<ICommentListContainerProp> {
  public render(): JSX.Element {
    return (
      <div className={'comment-list-container'}>
        {this.getCommentList()}
      </div>
    );
  }

  private getCommentList() {
    const commentStore = this.props.commentStore;
    if (true) {
      return (<CommentList
        hasMore={commentStore.hasMore}
        commentItems={commentStore.items}
        onNext={this.loadMore}
        onClickCommentItem={this.onClickCommentItem}
        onLikeItem={this.props.commentStore.likeItem}
      >
      </CommentList>);
    } else {
      // return <CommentEmpty emptyMessage={'no comment'}></CommentEmpty>;
    }
  }

  private loadMore = () => {
    // console.log('>load more', JSON.stringify(this.props.commentStore.toJson(), null, 4));
    if (process.env.BROWSER) {
      this.props.commentStore.loadCommentList(this.props.commentStore.lastIndex);
    }
  }

  private onClickCommentItem = (commentItem: ICommonCommentItem) => {
    // const commentStore = this.props.commentStore;
    const env = window._ENVI_INFO;
    const commonParams = commonParamBuilder.getParams(queryString.parse(location.search));
    const urlQuires = Object.assign(commonParams, {
      item_id: commentItem.itemId,
      comment_id: commentItem.commentId,
    });
    const url = `${location.protocol}//${location.host}/${env.siteKey}/comment/detail/story?${queryString.stringify(urlQuires)}`;
    callSdkMethod('comment', 'openCommentWebview')({
      url,
      show_comment_count: false,
      comment_id: commentItem.commentId,
      comment_ref_id: `${commentItem.itemId}_comment`,
      article_id: commentItem.itemId,
      type: 1,
      reply_user_name: commentItem.userName,
      reply_user_id: commentItem.userId,
      comment_stat: 1,
    }).catch((err) => {
      location.href = url;
    });
  }

}
